import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllBanner } from "../apis/authApi";

const TimeBanner = () => {

  const [banner,setBanner] = useState()

  useEffect(()=>{
    getAllBanner().then(res=>{
      const ban = res?.data?.find(b=>b.name === "Time Banner")
      setBanner(ban.image)
    }).catch(err=>console.log(err))
  },[])
  return (
    <div className=" w-full h-screen relative flex justify-center items-center">
      <img
        src={banner||"assets/banner/shop-banner-36.jpeg"}
        alt="banner1"
        className=" w-full h-full object-center object-cover"
      />
      <div className=" p-10 bg-white absolute md:left-16 top-36 text-center mx-3">
        <h1 className=" text-4xl font-bold">Get -50% from <br />Summer Collection</h1>
        <h5 className=" text-[14px] font-semibold mt-2">Hurry up! Limited time offer</h5>
        <div className=" flex justify-center items-center gap-4 mt-8">
          <div>
            <div className=" text-2xl font-bold text-red-600">00</div>
            <div className=" text-[14px] text-gray-600">DAY</div>
          </div>
          <div>
            <div className=" text-2xl font-bold text-red-600">00</div>
            <div className=" text-[14px] text-gray-600">HOUR</div>
          </div>
          <div>
            <div className=" text-2xl font-bold text-red-600">00</div>
            <div className=" text-[14px] text-gray-600">MINUTE</div>
          </div>
          <div>
            <div className=" text-2xl font-bold text-red-600">00</div>
            <div className=" text-[14px] text-gray-600">SECOND</div>
          </div>
        </div>
       <Link to='/shop'>
        <button className=" bg-red-600 text-white font-semibold text-[15px] p-3 px-6 mt-5">Shop Now</button>
        </Link>
      </div>
    </div>
  );
};

export default TimeBanner;
